
import { Component, Prop, Vue } from "vue-property-decorator";
import VueScrollTo from "vue-scrollto";
import { AmTabs } from "@afe/amui/src/components/Tabs";

@Component({
  inheritAttrs: false,
  components: {
    AmTabs
  }
})
export default class extends Vue {
  @Prop(String) readonly tabsClass?: string;
  @Prop({ type: Number, default: 1024 }) breakpoint!: number;
  @Prop(Array) readonly tabs!: Array<{
    value: number;
    target: string;
    label: string;
  }>;
  value = 0;
  offsetBlock = 100;

  onChange(value: number) {
    const target = this.tabs[value].target;

    VueScrollTo.scrollTo(target, 200, {
      container: "body",
      offset: -this.offsetBlock,
      easing: "ease-in",
      lazy: false
    } as any);
  }
}
